import { API_URL } from "../constants";
import { HTTPClient, APIRequest, RequestType } from "../services/http_client";
import { Category } from "../types/categories";

interface CategoriesResponse {
    categories: Array<Category>;
  }

const client = new HTTPClient()

class CategoriesModel {
    static async getAll(){
        const request = new APIRequest(
            RequestType.GET,
            `${API_URL}/categories`
        )

        const response = await client.get(request)

        if (!response.success) {
            return {
                error: response.errorMessage,
                data: {},
            }
        }

        const data = response.result as unknown as CategoriesResponse

        return {
            error: undefined,
            data,
        }
    }
}

export default CategoriesModel